export default {
  form : {
    datum_aanvraag: null,
    geboortedatum: null,
    datum_aanvang: null,
    datum_einde: null
  }
}



// WEBPACK FOOTER //
// ./src/state.js